import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { faArrowDownAZ, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import useFilter from "../../../../../hook/useFilter";
import useVariable from "../../../../../hook/useVariable";
import { fileActions } from "../../../../../store/files-slice";
import InfoIcon from "../../../../InfoIcon";
import Pagination from "./pagination";
import Resort from "./resort";

export default function Filter({ children }) {
    const [showFilter, setShowFilter] = useState(false);
    const [isMount, setIsMount] = useState(false);
    const filterCounts = useSelector(state => state.file.filterfileCount);
    const pagination = useSelector(state => state.file.pagination);
    const filters = useSelector(state => state.file.filter);
    const files = useSelector(state => state.file.files);
    const dispatch = useDispatch();
    const { doFilter } = useFilter();
    const { variableValue } = useVariable();

    useEffect(() => {
        if (!isMount) {
            setIsMount(true);
            return;
        }
        doFilter(filters, files, fileActions);
    }, [filters]);

    return <div className="p-1">
        <Link className="btn btn-outline-secondary mb-2" to="/admin/uploadmanagement"><InfoIcon icon={faFileUpload} /> Upload File</Link>
        <button type="button" className="card shadow bg-white rounded p-3 mb-3 w-100 border-0" aria-expanded={showFilter} onClick={() => setShowFilter(current => !current)}>
            <InfoIcon icon={faArrowDownAZ} size="xl" title="Filter and sort" />
        </button>
        {showFilter && <Fragment>
            <label htmlFor="file-mobile-pagination">Pagination</label>
            <select id="file-mobile-pagination" value={filters.pagination || ""} className="form-select mb-2" onChange={event => dispatch(fileActions.setFilter({ key: "pagination", value: variableValue(event.target.value) }))}>
                <option value="">All</option>
                {filterCounts.map(count => <option key={count} value={count}>{count}</option>)}
            </select>
            <Resort type="id" name="ID" />
            <Resort type="name" name="Name" />
            <Resort type="storepath" name="StorePath" />
            <Resort type="identifier" name="Identifier" />
            <Resort type="type" name="Type" />
            <Resort type="created_on" name="CreatedOn" />
        </Fragment>}
        <input type="search" className="form-control mb-3" value={filters.search || ""} placeholder="filename, filetype or identifier" aria-label="Search files" onChange={event => dispatch(fileActions.setFilter({ key: "search", value: variableValue(event.target.value) }))} />
        {children}
        {pagination && <div className="pagination-container">{pagination.map((page, index) => <Pagination key={index} files={page} index={index} />)}</div>}
    </div>;
}
